import { createLink } from '@tanstack/react-router';
import Button, { type ButtonProps } from '@mui/material/Button';
import { forwardRef } from 'react';

// see example: https://tanstack.com/router/latest/docs/how-to/integrate-material-ui
export const RouterButton = createLink(
  forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    return <Button ref={ref} component="button" {...props} />
  }),
)